import { JobQueueStatus } from '@alpod-ai-writer/backend/src/db/schema';
import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';

import { useApi } from '../../api/useApi.hook';

export const useDocumentJobs = (documentId?: string) => {
    const api = useApi();
    const [ hasJobs, setHasJobs ] = useState(false);

    const jobList = useQuery({
        queryKey: ['documents', documentId, 'jobs'],
        queryFn: async () => {
            return api.v1.documents.getJobList(documentId!, {
                filter: [ 'and', [
                    [ 'or' , [
                        [ 'status', 'eq', JobQueueStatus.Pending ],
                        [ 'status', 'eq', JobQueueStatus.InProgress ],
                        [ 'status', 'eq', JobQueueStatus.Completed ],
                        [ 'status', 'eq', JobQueueStatus.Failed ],
                    ]],
                    [ 'dismissedAt', 'eq', null ]
                ]],
                limit: 30,
                offset: 0
            });
        },
        refetchInterval: hasJobs ? 2000 : 5000,
        enabled: !!documentId
    });

    useEffect(() => {
        if (jobList.data?.count) {
            setHasJobs(true);
        } else {
            setHasJobs(false);
        }
    }, [ jobList.data?.count ]);

    return {
        jobList
    };
};
